var _dec, _dec2, _class, _descriptor, _descriptor2, _dec3, _dec4, _dec5, _class2, _class3, _descriptor3, _descriptor4;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import CatalogMemberTraits from "./CatalogMemberTraits";
import GroupTraits from "./GroupTraits";
import mixTraits from "../mixTraits";
import ModelTraits from "../ModelTraits";
import objectArrayTrait from "../Decorators/objectArrayTrait";
import primitiveTrait from "../Decorators/primitiveTrait";
import UrlTraits from "./UrlTraits";
import LegendOwnerTraits from "./LegendOwnerTraits";
import { traitClass } from "../Trait";
export let RefineTraits = (_dec = primitiveTrait({
  name: "Facet name",
  type: "string",
  description: "Name of facet"
}), _dec2 = primitiveTrait({
  name: "Facet value",
  type: "string",
  description: "Value of facet to use as filter"
}), _class = class RefineTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "name", _descriptor, this);
    _initializerDefineProperty(this, "value", _descriptor2, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "name", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "value", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
let OpenDataSoftCatalogGroupTraits = (_dec3 = traitClass({
  description: "Creates one catalog group from url that points to an opendatasoft service.",
  example: {
    name: "opendatasoft-group example",
    type: "opendatasoft-group",
    url: "https://data.bmcc.nsw.gov.au",
    facetFilters: [{
      name: "features",
      value: "geo"
    }],
    id: "some unique id"
  }
}), _dec4 = primitiveTrait({
  type: "boolean",
  name: "Flatten",
  description: "True to flatten the layers into a single list; false to use the layer hierarchy."
}), _dec5 = objectArrayTrait({
  name: "Facets filter",
  type: RefineTraits,
  description: "Facets (key/value pairs) to use to filter datasets.",
  idProperty: "name"
}), _dec3(_class2 = (_class3 = class OpenDataSoftCatalogGroupTraits extends mixTraits(UrlTraits, CatalogMemberTraits, LegendOwnerTraits, GroupTraits) {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "flatten", _descriptor3, this);
    _initializerDefineProperty(this, "facetFilters", _descriptor4, this);
  }
}, _descriptor3 = _applyDecoratedDescriptor(_class3.prototype, "flatten", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class3.prototype, "facetFilters", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class3)) || _class2);
export { OpenDataSoftCatalogGroupTraits as default };